import React from 'react'

import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'

import CareTimeline from './CareTimeline'
import Sessions from '../sessions/Sessions'

const CareTimelineRoute: React.FC = () => {
  const { isClientHeaderRedesignEnabled, isDBTTeensEnabled } = useFlags()

  if (isClientHeaderRedesignEnabled) {
    return <CareTimeline />
  }

  return <Sessions withProgramAwareSessionsExperience={isDBTTeensEnabled} />
}

export default CareTimelineRoute
